/* global locale */

import Vue from 'vue/dist/vue.esm'
import TurbolinksAdapter from 'vue-turbolinks'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import { messages } from 'default/translated_text'
Vue.use(TurbolinksAdapter)
import hotelCarousel from './hotel_carousel'

function renderVue() {
  if (!document.getElementById('admin-hotel-image-container')) return
  const i18n = new VueI18n({ locale, messages, fallbackLocale: 'en' })
  return new Vue({
    i18n,
    render: h => h(hotelCarousel)
  }).$mount('#admin-hotel-image-container')
}

document.addEventListener('turbolinks:load', () => {
  renderVue()
})